/* Mint style — trang sản phẩm (sections/mt-product.liquid). Bê từ theme Capitol cũ (gv-product.js), đổi tên lớp sang mt-pd:
   - Ảnh: mũi tên tròn 2 bên, ảnh nhỏ bên dưới (máy tính), chấm tròn + vuốt (điện thoại / máy tính bảng).
   - Bấm ảnh: xem toàn màn hình (phóng to / thu nhỏ, mũi tên, ảnh nhỏ hoặc chấm), Esc hoặc X để đóng.
   - Số lượng – / +, chọn phiên bản (nếu có), ngày gửi hàng dự kiến (nếu bật).
   - Các dòng gập mở Details / Shipping / FAQs / Reviews.
   - Hàng sản phẩm gợi ý: tải sau khi trang xong (không làm chậm trang), có mũi tên trượt.
   - Điện thoại: nút Add to Cart dính đáy màn hình khi chỗ số lượng + nút không nằm trọn trong màn hình.
   - Trình chỉnh sửa theme: chọn khối FAQ → mở dòng FAQs và câu hỏi đó. */
(function () {
  if (window.__mtProduct) return; window.__mtProduct = 1;
  var reduce = matchMedia('(prefers-reduced-motion: reduce)');
  var mobile = matchMedia('(max-width: 989px)');
  function beh() { return reduce.matches ? 'auto' : 'smooth'; }
  function each(list, fn) { Array.prototype.forEach.call(list, fn); }
  function clamp(i, n) { return Math.max(0, Math.min(n - 1, i)); }
  function loadImg(im) { if (im && im.dataset.src) { im.src = im.dataset.src; im.removeAttribute('data-src'); } }
  function onMq(mq, fn) { if (mq.addEventListener) mq.addEventListener('change', fn); else mq.addListener(fn); }

  /* ---------- Ảnh chính ---------- */
  function gallery(root) {
    var track = root.querySelector('.mt-pd__track');
    var api = { cur: 0, go: function () {} };
    if (!track) return api;
    var n = track.children.length;
    var thumbBox = root.querySelector('.mt-pd__thumbs');
    var thumbs = root.querySelectorAll('.mt-pd__thumbs .mt-pd__thumb');
    var dots = root.querySelectorAll('.mt-pd__dots .mt-pd__dot');
    var prev = root.querySelector('.mt-pd__arrow--prev'), next = root.querySelector('.mt-pd__arrow--next');
    function mark(i) {
      api.cur = i;
      each(thumbs, function (t, k) {
        t.classList.toggle('is-active', k === i);
        if (k === i) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current');
      });
      each(dots, function (d, k) { d.classList.toggle('is-active', k === i); });
      if (prev) prev.setAttribute('aria-disabled', i === 0 ? 'true' : 'false');
      if (next) next.setAttribute('aria-disabled', i === n - 1 ? 'true' : 'false');
      var t = thumbs[i];
      if (t && thumbBox && thumbBox.clientWidth) {
        var l = t.offsetLeft - thumbBox.offsetLeft, r = l + t.offsetWidth;
        if (l < thumbBox.scrollLeft) thumbBox.scrollTo({ left: l, behavior: beh() });
        else if (r > thumbBox.scrollLeft + thumbBox.clientWidth) thumbBox.scrollTo({ left: r - thumbBox.clientWidth, behavior: beh() });
      }
    }
    /* Đang trượt tới 1 ảnh (bấm mũi tên / ảnh nhỏ): giữ đích, không nhận vị trí giữa chừng */
    var target = -1;
    api.go = function (i, instant) {
      i = clamp(i, n);
      target = instant ? -1 : i;
      track.scrollTo({ left: i * track.clientWidth, behavior: instant ? 'auto' : beh() });
      mark(i);
    };
    var raf = 0;
    track.addEventListener('scroll', function () {
      if (raf) return;
      raf = requestAnimationFrame(function () {
        raf = 0;
        if (target >= 0) { if (Math.abs(track.scrollLeft - target * track.clientWidth) < 2) target = -1; return; }
        var i = clamp(Math.round(track.scrollLeft / Math.max(1, track.clientWidth)), n); if (i !== api.cur) mark(i);
      });
    }, { passive: true });
    ['pointerdown', 'touchstart', 'wheel'].forEach(function (ev) { track.addEventListener(ev, function () { target = -1; }, { passive: true }); });
    if (prev) prev.addEventListener('click', function () { if (api.cur > 0) api.go(api.cur - 1); });
    if (next) next.addEventListener('click', function () { if (api.cur < n - 1) api.go(api.cur + 1); });
    each(thumbs, function (t) { t.addEventListener('click', function () { api.go(+t.dataset.index); }); });
    /* Đổi cỡ màn hình: giữ đúng ảnh đang xem */
    if ('ResizeObserver' in window) new ResizeObserver(function () { track.scrollLeft = api.cur * track.clientWidth; }).observe(track);
    mark(0);
    return api;
  }

  /* ---------- Xem toàn màn hình ---------- */
  function viewer(root, gal) {
    var dlg = root.querySelector('[data-mt-fs]');
    if (!dlg || typeof dlg.showModal !== 'function') return;
    var ft = dlg.querySelector('.mt-pd__fs-track'), slides = ft.children, n = slides.length;
    var thumbs = dlg.querySelectorAll('.mt-pd__fs-thumbs .mt-pd__thumb'), dots = dlg.querySelectorAll('.mt-pd__fs-dots .mt-pd__dot');
    var prev = dlg.querySelector('.mt-pd__fs-prev'), next = dlg.querySelector('.mt-pd__fs-next');
    var zin = dlg.querySelector('[data-fs-zoom="1"]'), zout = dlg.querySelector('[data-fs-zoom="-1"]');
    var closeBtn = dlg.querySelector('[data-fs-close]');
    var html = document.documentElement, cur = 0, zoom = 1, ZMAX = 3;
    function frame(i) { return slides[i] && slides[i].querySelector('.mt-pd__fs-frame'); }
    function setZoom(z) {
      var f = frame(cur); if (!f) return;
      var img = f.querySelector('img');
      var cx = (f.scrollLeft + f.clientWidth / 2) / Math.max(1, f.scrollWidth), cy = (f.scrollTop + f.clientHeight / 2) / Math.max(1, f.scrollHeight);
      zoom = Math.max(1, Math.min(ZMAX, z));
      img.style.width = img.style.height = zoom === 1 ? '' : (zoom * 100) + '%';
      dlg.classList.toggle('is-zoomed', zoom > 1);
      f.scrollLeft = cx * f.scrollWidth - f.clientWidth / 2;
      f.scrollTop = cy * f.scrollHeight - f.clientHeight / 2;
      if (zin) zin.setAttribute('aria-disabled', zoom >= ZMAX ? 'true' : 'false');
      if (zout) zout.setAttribute('aria-disabled', zoom <= 1 ? 'true' : 'false');
    }
    function mark(i) {
      if (i !== cur && zoom > 1) setZoom(1);
      cur = i;
      for (var k = i - 1; k <= i + 1; k++) if (slides[k]) loadImg(slides[k].querySelector('img'));
      each(thumbs, function (t, k) {
        t.classList.toggle('is-active', k === i);
        if (k === i) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current');
      });
      each(dots, function (d, k) { d.classList.toggle('is-active', k === i); });
      if (prev) prev.setAttribute('aria-disabled', i === 0 ? 'true' : 'false');
      if (next) next.setAttribute('aria-disabled', i === n - 1 ? 'true' : 'false');
    }
    var target = -1;
    function go(i, instant) {
      i = clamp(i, n);
      if (zoom > 1) setZoom(1);
      target = instant ? -1 : i;
      ft.scrollTo({ left: i * ft.clientWidth, behavior: instant ? 'auto' : beh() });
      mark(i);
    }
    function open(i) {
      each(thumbs, function (t) { loadImg(t.querySelector('img')); });
      dlg.showModal();
      html.setAttribute('scroll-lock', '');
      cur = -1; zoom = 1; cur = clamp(i, n); setZoom(1);
      go(i, true);
      if (closeBtn) closeBtn.focus();
    }
    dlg.addEventListener('close', function () {
      html.removeAttribute('scroll-lock');
      if (zoom > 1) setZoom(1);
      gal.go(cur, true);
    });
    each(root.querySelectorAll('.mt-pd__zoom'), function (b) { b.addEventListener('click', function () { open(+b.dataset.index); }); });
    if (closeBtn) closeBtn.addEventListener('click', function () { dlg.close(); });
    if (prev) prev.addEventListener('click', function () { if (cur > 0) go(cur - 1); });
    if (next) next.addEventListener('click', function () { if (cur < n - 1) go(cur + 1); });
    if (zin) zin.addEventListener('click', function () { setZoom(zoom + 1); });
    if (zout) zout.addEventListener('click', function () { setZoom(zoom - 1); });
    each(thumbs, function (t) { t.addEventListener('click', function () { go(+t.dataset.fsIndex); }); });
    dlg.addEventListener('keydown', function (e) {
      if (zoom > 1) return;
      if (e.key === 'ArrowLeft') { e.preventDefault(); if (cur > 0) go(cur - 1); }
      else if (e.key === 'ArrowRight') { e.preventDefault(); if (cur < n - 1) go(cur + 1); }
    });
    var raf = 0;
    ft.addEventListener('scroll', function () {
      if (raf || zoom > 1) return;
      raf = requestAnimationFrame(function () {
        raf = 0;
        if (target >= 0) { if (Math.abs(ft.scrollLeft - target * ft.clientWidth) < 2) target = -1; return; }
        var i = clamp(Math.round(ft.scrollLeft / Math.max(1, ft.clientWidth)), n); if (i !== cur) mark(i);
      });
    }, { passive: true });
    ['pointerdown', 'touchstart', 'wheel'].forEach(function (ev) { ft.addEventListener(ev, function () { target = -1; }, { passive: true }); });
    /* Kéo ảnh khi đang phóng to (chuột) */
    var drag = null;
    ft.addEventListener('pointerdown', function (e) {
      if (zoom === 1 || e.pointerType !== 'mouse' || e.button !== 0) return;
      var f = frame(cur); drag = { f: f, x: e.clientX, y: e.clientY, l: f.scrollLeft, t: f.scrollTop }; e.preventDefault();
    });
    addEventListener('pointermove', function (e) { if (drag) { drag.f.scrollLeft = drag.l - (e.clientX - drag.x); drag.f.scrollTop = drag.t - (e.clientY - drag.y); } });
    addEventListener('pointerup', function () { drag = null; });
    if ('ResizeObserver' in window) new ResizeObserver(function () { if (dlg.open && zoom === 1) ft.scrollLeft = cur * ft.clientWidth; }).observe(ft);
  }

  /* ---------- Số lượng – / + ---------- */
  function qty(root) {
    var inp = root.querySelector('[data-mt-qty]'); if (!inp) return;
    function fix(v) {
      var min = parseInt(inp.min, 10) || 1, step = parseInt(inp.step, 10) || 1, max = inp.max ? parseInt(inp.max, 10) : Infinity;
      if (isNaN(v) || v < min) v = min;
      v = min + Math.round((v - min) / step) * step;
      if (v > max) v = max - ((max - min) % step);
      return v;
    }
    each(root.querySelectorAll('.mt-pd__qty-btn'), function (b) {
      b.addEventListener('click', function () {
        var step = parseInt(inp.step, 10) || 1;
        inp.value = fix((parseInt(inp.value, 10) || 0) + step * +b.dataset.step);
      });
    });
    inp.addEventListener('change', function () { inp.value = fix(parseInt(inp.value, 10)); });
    var form = inp.form;
    if (form) form.addEventListener('submit', function () { inp.value = fix(parseInt(inp.value, 10)); }, true);
  }

  /* ---------- Ngày gửi hàng dự kiến (ngày làm việc T2–T6, theo giờ máy khách) ---------- */
  function shipText(el) {
    var d = new Date(), n = parseInt(el.dataset.days, 10) || 0;
    while (n > 0) { d.setDate(d.getDate() + 1); var w = d.getDay(); if (w !== 0 && w !== 6) n--; }
    function p2(x) { return (x < 10 ? '0' : '') + x; }
    el.textContent = el.dataset.label + ' ' + p2(d.getMonth() + 1) + '/' + p2(d.getDate()) + '/' + d.getFullYear();
  }

  /* ---------- Chọn phiên bản ---------- */
  function variants(root, gal) {
    var data = root.querySelector('[data-mt-variants]'); if (!data) return;
    var list; try { list = JSON.parse(data.textContent); } catch (e) { return; }
    var sels = root.querySelectorAll('[data-mt-option]');
    var price = root.querySelector('[data-mt-price]'), stock = root.querySelector('[data-mt-stock]');
    var ship = root.querySelector('[data-mt-ship]'), sku = root.querySelector('[data-mt-sku]');
    var btn = root.querySelector('[data-mt-atc]'), qin = root.querySelector('[data-mt-qty]');
    function esc(s) { var d = document.createElement('div'); d.textContent = s; return d.innerHTML; }
    function update() {
      var opts = Array.prototype.map.call(sels, function (s) { return s.value; });
      var v = null;
      for (var i = 0; i < list.length; i++) if (list[i].options.join('\u0001') === opts.join('\u0001')) { v = list[i]; break; }
      var ok = !!(v && v.available);
      if (v) {
        each(root.querySelectorAll('[data-mt-id]'), function (inp) { inp.value = v.id; inp.dispatchEvent(new Event('change', { bubbles: true })); });
        if (price) price.innerHTML = (v.compare ? '<span class="mt-sr-only">' + esc(price.dataset.srReg) + '</span><s class="mt-pd__was">' + esc(v.compare) + '</s><span class="mt-sr-only">' + esc(price.dataset.srSale) + '</span>' : '') + '<span class="mt-pd__now">' + esc(v.price) + '</span>';
        if (sku) { sku.hidden = !v.sku; sku.textContent = sku.dataset.label + ' ' + v.sku; }
        if (qin) { qin.min = v.min || 1; if ((parseInt(qin.value, 10) || 0) < qin.min) qin.value = qin.min; }
        try { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(history.state, '', u.toString()); } catch (e) {}
        if (v.media) {
          var sl = root.querySelectorAll('.mt-pd__slide');
          for (var k = 0; k < sl.length; k++) if (sl[k].dataset.mediaId === String(v.media)) { gal.go(k); break; }
        }
      }
      if (stock) { stock.textContent = ok ? stock.dataset.in : stock.dataset.out; stock.classList.toggle('is-out', !ok); }
      if (ship) ship.hidden = !ok;
      if (btn) {
        btn.disabled = !ok;
        var t = btn.querySelector('.mt-pd__atc-t');
        if (t && !btn.classList.contains('is-busy')) t.textContent = ok ? btn.dataset.add : btn.dataset.sold;
      }
    }
    each(sels, function (s) { s.addEventListener('change', update); });
  }

  /* ---------- Dòng gập mở ---------- */
  function tabs(root) {
    var box = root.querySelector('[data-mt-tabs]'); if (!box) return;
    /* Khung Ryviu tự gắn: nếu store không bật app Ryviu (không có script Ryviu) thì bỏ mục Reviews cho gọn */
    var ry = box.querySelector('[data-mt-ryviu]');
    if (ry && !document.querySelector('script[src*="ryviu"]')) {
      ry.parentNode.removeChild(ry);
      each(root.querySelectorAll('[data-mt-goto="reviews"]'), function (a) {
        var sp = document.createElement('span'); sp.className = a.className; sp.textContent = a.textContent; a.parentNode.replaceChild(sp, a);
      });
    }
    if (!box.querySelector('.mt-pd__sec')) box.hidden = true;
    function set(sec, open) {
      sec.classList.toggle('is-open', open);
      var p = sec.querySelector('.mt-pd__panel'); if (p) p.hidden = !open;
      var b = sec.querySelector('.mt-pd__acc-btn'); if (b) b.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
    each(box.querySelectorAll('.mt-pd__acc-btn'), function (b) {
      b.addEventListener('click', function () { var sec = b.closest('.mt-pd__sec'); set(sec, !sec.classList.contains('is-open')); });
    });
    /* "12 Reviews" dưới tên sản phẩm: mở mục đánh giá và cuộn tới */
    each(root.querySelectorAll('[data-mt-goto]'), function (a) {
      a.addEventListener('click', function (e) {
        var sec = box.querySelector('[data-sec="' + a.dataset.mtGoto + '"]'); if (!sec) return;
        e.preventDefault(); set(sec, true);
        sec.scrollIntoView({ behavior: beh(), block: 'start' });
      });
    });
    root.__mtOpenSec = set;
  }

  /* ---------- Sản phẩm gợi ý (tải sau) ---------- */
  function strip(stage) {
    var track = stage.querySelector('.mt-pd__rtrack'); if (!track) return;
    var prev = stage.querySelector('[data-rdir="-1"]'), next = stage.querySelector('[data-rdir="1"]');
    function upd() {
      var max = track.scrollWidth - track.clientWidth;
      stage.classList.toggle('is-static', max < 4);
      if (prev) prev.disabled = track.scrollLeft < 4;
      if (next) next.disabled = track.scrollLeft > max - 4;
    }
    function step(dir) {
      var it = track.querySelector('.mt-pd__ritem'); if (!it) return;
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      var w = it.getBoundingClientRect().width + gap, per = Math.max(1, Math.floor((track.clientWidth + gap) / w + 0.02));
      track.scrollBy({ left: dir * per * w, behavior: beh() });
    }
    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });
    track.addEventListener('scroll', function () { requestAnimationFrame(upd); }, { passive: true });
    if ('ResizeObserver' in window) new ResizeObserver(upd).observe(track);
    upd();
  }
  function recs(root) {
    var box = root.querySelector('[data-mt-recs]'); if (!box || !box.dataset.url) return;
    function load() {
      fetch(box.dataset.url, { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.text() : ''; }).then(function (text) {
        if (!text) return;
        var doc = new DOMParser().parseFromString(text, 'text/html');
        var stage = doc.querySelector('[data-mt-recs-ready]');
        if (!stage || !stage.querySelector('li')) return;
        box.innerHTML = '';
        if (box.dataset.title) {
          var h = document.createElement('h2'); h.className = 'mt-pd__recs-title'; h.textContent = box.dataset.title; box.appendChild(h);
        }
        var node = document.importNode(stage, true);
        box.appendChild(node);
        strip(node);
      }).catch(function () {});
    }
    function later() { ('requestIdleCallback' in window) ? requestIdleCallback(load, { timeout: 2500 }) : setTimeout(load, 800); }
    (document.readyState === 'complete') ? later() : addEventListener('load', later, { once: true });
  }

  /* ---------- Điện thoại: nút Add to Cart dính đáy khi chỗ số lượng + nút không nằm trọn trong màn hình ---------- */
  function stickyBuy(root) {
    var slot = root.querySelector('[data-mt-slot]'), box = root.querySelector('.mt-pd__buy');
    if (!slot || !box) return;
    var seen = true;
    function apply() { slot.classList.toggle('is-stuck', mobile.matches && !seen); }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { seen = es[es.length - 1].intersectionRatio >= 0.99; apply(); }, { threshold: [0, 0.5, 0.99, 1] }).observe(box);
    } else {
      var check = function () { var r = box.getBoundingClientRect(); seen = r.top >= 0 && r.bottom <= innerHeight; apply(); };
      addEventListener('scroll', check, { passive: true }); addEventListener('resize', check); check();
    }
    onMq(mobile, apply);
  }

  function init(root) {
    if (!root || root.__mtpd) return; root.__mtpd = 1;
    var gal = gallery(root);
    viewer(root, gal);
    qty(root);
    stickyBuy(root);
    var ship = root.querySelector('[data-mt-ship]'); if (ship) shipText(ship);
    /* Trả góp: chỉ chừa khoảng cách khi Shopify thật sự hiện dòng trả góp */
    var terms = root.querySelector('[data-mt-terms]');
    if (terms && 'ResizeObserver' in window) new ResizeObserver(function () { terms.classList.toggle('has-terms', terms.offsetHeight > 0); }).observe(terms);
    variants(root, gal);
    tabs(root);
    recs(root);
  }
  function scan(r) { each((r || document).querySelectorAll('[data-mt-pd]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { scan(); }); else scan();
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
  /* Nút copy link (chia sẻ) */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-mt-pcopy]'); if (!b) return;
    var url = b.getAttribute('data-mt-pcopy'), msg = b.parentElement.querySelector('.mt-pd__copied');
    function done() { if (msg) { msg.textContent = b.getAttribute('data-done') || 'Link copied'; clearTimeout(b.__t); b.__t = setTimeout(function () { msg.textContent = ''; }, 2500); } }
    function old() { var t = document.createElement('textarea'); t.value = url; t.setAttribute('readonly', ''); t.style.cssText = 'position:fixed;opacity:0;top:0'; document.body.appendChild(t); t.select(); var okc = false; try { okc = document.execCommand('copy'); } catch (er) {} t.remove(); if (okc) done(); }
    if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(url).then(done, old); else old();
  });
  /* Trình chỉnh sửa theme: chọn khối FAQ → mở dòng FAQs và câu hỏi đó */
  document.addEventListener('shopify:block:select', function (e) {
    var faq = e.target && e.target.closest && e.target.closest('.mt-pd__faq'); if (!faq) return;
    var root = faq.closest('[data-mt-pd]'), sec = faq.closest('.mt-pd__sec');
    if (root && root.__mtOpenSec && sec) root.__mtOpenSec(sec, true);
    faq.open = true;
  });
})();
